<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <h2 class="text-center">Edycja parkingu: {{ parking.name }}</h2>
    <form @submit.prevent="UpdateParking()">

      <div class="mb-3">
        <label for="place-name" class="form-label">Nazwa parkingu</label>
        <input type="text" class="form-control" id="placeName" placeholder="Nazwa parkingu" v-model="parking.name">
      </div>

      <div class="mb-3">
        <label for="place-name" class="form-label">opis</label>
        <input type="text" class="form-control" id="placeStreet" placeholder="Opis parkingu" v-model="parking.description">
      </div>

      <div class="mb-3">
        <label for="place-name" class="form-label">adres</label>
        <input type="text" class="form-control" id="placeStreet" placeholder="Adres parkingu" v-model="parking.address">
      </div>

      <button type="submit" class="btn btn-primary">Zatwierdź</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Navbar from '@/components/Navbar'

export default {
  name: 'CreateTrailer',
  components: { Navbar },
  data () {
    return {
      parking: {}
    }
  },
  mounted () {
    this.FetchParking()
  },
  methods: {
    UpdateParking () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.put(`${process.env.VUE_APP_API_BASE_URL}Parking/${this.$route.params.id}`, this.parking, config)
        .then( (response) => {
          Swal.fire( 'sukces!', 'Pomyślnie edytowano parking', 'success' )
          this.$router.push({ name: 'ParkingList' })
        }).catch((err) => { console.log(err) })
    },
    FetchParking () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.get(`${process.env.VUE_APP_API_BASE_URL}Parking/${this.$route.params.id}`, config)
        .then( (response) => {
          this.parking = response.data
        }).catch((err) => { console.log(err) })
    }
  }
}
</script>
